<template>
  <div class="box" style="font-family: SourceHanSansCN-Regular">
    <div class="content">
      <div>
        <img v-lazy="item.avatar" class="icon" />
      </div>
      <div class="descBox">
        <div class="nameDateBox">
          <div :class="{ vipText: item.isVip }" class="vipBox">
            {{ log(item) }}
            {{ item.nick_name }}
            <div v-if="item.isVip" class="vip"></div>
            <div v-else :class="item.isVip" class="vip-no"></div>
          </div>
          <div class="timeStamp">
            {{ timeStep(item.created_at) }}
          </div>
        </div>
        <div class="textBox">
          {{ item.text }}
        </div>
        <div class="response" v-if="item.reply !== undefined">
          <span class="person">{{ item.reply.author }}:</span>
          {{ item.reply.text }}
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  name: "Comment",
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  methods: {
    log(test) {
      console.log(test);
    },
    timeStep(time) {
      console.log(time);
      // time=
      const minute = 1000 * 60;
      const hour = minute * 60;
      const day = hour * 24;
      const halfamonth = day * 15;
      const month = day * 30;
      const year = day * 365;
      const now = new Date().getTime();
      // console.log(now)
      const diffValue = now - new Date(time.replace(/-/g, "/")).getTime();
      if (diffValue < 0) {
        return;
      }
      const yearC = diffValue / year;
      const monthC = diffValue / month;
      const weekC = diffValue / (7 * day);
      const dayC = diffValue / day;
      const hourC = diffValue / hour;
      const minC = diffValue / minute;

      let result = "刚刚";
      if (weekC >= 1) {
        // time=time+''
        result = time.slice(0, 10);
      } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
      } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
      } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
      } else {
        result = "刚刚";
        // result=new Date(time).getTime()
      }
      return result;
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.vip {
  height: 10px;
  background-image: url("./../assets/img/my/isVip.png");
  background-position: center;
  background-size: contain;
  /*background-size: 100%;*/
}

.vip-no {
  height: 15px;
  background: url("./../assets/img/my/vip-no.png") no-repeat center center;
  background-size: 100%, 100%;
  background-position: bottom;
}

.icon {
  width: 35px;
  /*min-height: 1.5rem;*/
  border-radius: 50%;
}

.content {
  /*padding-left: 25px;*/
  /*padding-right: 25px;*/
  display: flex;
}

.nameDateBox {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  /*align-items: end;*/
}

.descBox {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.textBox {
  text-align: justify;
  padding-bottom: 10px;
  line-height: 17px;
  padding-right: 10px;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 22px;
  /*letter-spacing: 1px;*/
}

.timeStamp {
  align-self: flex-end;
  color: #9b9b9b;
  font-size: 13px;
}

hr {
  color: rgba(234, 234, 234, 1);
  margin: 10px;
}

.box {
  padding-left: 20px;
  padding-right: 15px;
}

.vipText {
  color: #f7b270;
}

.vipBox {
  display: flex;
  align-items: center;
}

.response {
  margin-left: 20px;
  /*width: 100%;*/
  /*height: 100px;*/
  padding: 10px;
  background: rgba(236, 239, 245, 1);
  font-size: 14px;
  line-height: 20px;

  .person {
    color: rgba(116, 135, 195, 1);
  }

  .content {
  }
}
</style>
